import * as firestore from 'firebase/firestore';
import { DateTime } from 'luxon';
import { TimeClock } from '../types/TimeClock';

export default {
  toFirestore(timeClock: TimeClock): firestore.DocumentData {
    let data: {[field: string]: any} = {
      idNumber: timeClock.idNumber,
      name: timeClock.name,
    };

    if (timeClock.timeIn) {
      data = {
        ...data,
        timeIn: firestore.Timestamp.fromDate(DateTime.fromISO(timeClock.timeIn).toJSDate()),
        timeInGeoPosition: timeClock.timeInGeoPosition,
      }
    }

    if (timeClock.timeOut) {
      data = {
        ...data,
        timeOut: firestore.Timestamp.fromDate(DateTime.fromISO(timeClock.timeOut).toJSDate()),
        timeOutGeoPosition: timeClock.timeOutGeoPosition,
      }
    }

    return data;
  },
  fromFirestore(
    snapshot: firestore.QueryDocumentSnapshot
  ): TimeClock {
    const data = snapshot.data()!;
    return {
        idNumber: data.idNumber,
        name: data.name,
        timeIn: data.timeIn ? DateTime.fromJSDate((data.timeIn as firestore.Timestamp).toDate()).toISO() : "",
        timeOut: data.timeOut ?  DateTime.fromJSDate((data.timeOut as firestore.Timestamp).toDate()).toISO() : "",
        timeInGeoPosition: data.timeInGeoPosition,
        timeOutGeoPosition: data.timeOutGeoPosition,
    };
  },
};
